import {
  LOAD_MENU,
  LOAD_MENU_ERROR,
  LOAD_MENU_SUCCESS,
  LOAD_OPERATIONS,
  LOAD_OPERATIONS_ERROR,
  LOAD_OPERATIONS_SUCCESS,
  UPDATE_OPERATIONS_FILTERS,
  SET_OPERATIONS_PAGE_SELECTED,
} from '../constants/operations';

export const LoadMenu = () => ({ type: LOAD_MENU });

export const LoadMenuSuccess = ({ menus }) => ({
  type: LOAD_MENU_SUCCESS,
  menus,
});

export const LoadMenuError = () => ({ type: LOAD_MENU_ERROR });

export const LoadOperations = (props) => ({
  type: LOAD_OPERATIONS,
  menuSelected: props?.menuSelected
});

export const LoadOperationsError = () => ({ type: LOAD_OPERATIONS_ERROR });

export const LoadOperationsSuccess = ({ operations, menu }) => ({
  type: LOAD_OPERATIONS_SUCCESS,
  operations,
  menu
});

export const UpdateOperationsFilters = ({ pageId, menuId, filters }) => ({
  type: UPDATE_OPERATIONS_FILTERS,
  pageId,
  menuId,
  filters,
});

export const SetOperationPageSelected = ({ pageId }) => ({
  type: SET_OPERATIONS_PAGE_SELECTED,
  pageId
});
